module.exports = __webpack_public_path__ + "media/images/set-limits-45ef63997b5a3f6038effb3dcb97aeea.svg";